module.exports = __webpack_public_path__ + "img/mode1-5.11ae3f8e.png";